export default "__VITE_ASSET__CNNI2B1Y__"